import Address from "./address";

const debug = false
// const debug = "Addresses"

export default class Addresses {

    private _models: Address[]

    constructor(models:Address[]=[]) {
        this._models = models
    }

    get isEmpty():boolean {
        return _.isEmpty(this._models)
    }

    get total():number {
        return this._models.length
    }

    static initFromJson(data:JSONArray) {
        const collection = new Addresses([])

        _.map(data, (record:JSONObject)=>{
            collection.add(Address.initFromJson(record))
        })

        return collection
    }


    add(vote: Address) {
        this._models.push(vote)
    }

    toOptions(){
        const options: Option[] = this._models.map((address: Address)=>{
            return {
                value: address,
                label: address.address
            }
        })

        return options
    }

    toJSON():JSONArray {
        return _.map(this._models, (model:Address)=>{
            return model.toJSON()
        })
    }
}
